import type { ButtonProps } from 'rsuite'
import React from 'react'

import IconEdit from '@rsuite/icons/Edit'
import { Button } from 'rsuite'
// import CheckOutlineIcon from '@rsuite/icons/CheckOutline'

export const SaveButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  return (
    <Button
      className="u-btn-submit"
      appearance="primary"
      color="violet"
      type="submit"
      size="lg"
      {...props}
    >
      {children}
    </Button>
  )
}

export const EditButton: React.FC<ButtonProps> = ({
  children = 'Изменить',
  ...props
}) => (
  <Button appearance="primary" color="cyan" {...props}>
    <IconEdit />
    &nbsp; {children}
  </Button>
)
